// import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
import React, { useState, useEffect } from "react";
import {BrowserRouter as Router,Link,useLocation} from "react-router-dom";
import {ThreeDots} from './ThreeDots';
import './DplayActivate.css';
import Axios from 'axios';
import {Button} from '@material-ui/core';

const defaultUrl="https://signup.viaplay.se/sappa?key1=16&key2=&emailToken=";


const ActivateSkyShowtime = async (ip) => {
    console.log("ActivateSkyShowtime ip: " + ip);

    let endpoint = 'https://skyshowtimetest.sappa.se/api/activation/test';

    fetch(endpoint,{method: 'POST',headers:{Authorization: '5DE06AEE6EF240A4A2BD6F749CDAE391ABA5FD6C3056443D92FA0B7E5BA5CC3B',source:ip}})
    .then(response =>{
        
        return response.json();
    } )
    .then(data => {
        console.log(data);
        
        if(data.ActivationUrl.length > 0 )
        {
            window.location.href =data.ActivationUrl;
        }
        
       
    })
    .catch(
        exp =>{
        console.log(exp);
        }
        );
}

// const getData = async () => {
//   // const res = await axios.get('https://geolocation-db.com/json/')
//   // console.log(res.data);
//   // setIP(res.data.IPv4)

//   fetch('https://api.ipify.org?format=json',{method: 'GET'})
//   .then(response =>{
      
//       return response.json();
//   } )
//   .then(data => {
    
//     console.log(data);
//     ActivateSkyShowtime(data.ip);
//     return data.IPv4;
     
//   })
//   .catch(
//       exp =>{
//       console.log(exp);
//       }
//       );



// }

function SkyShowtimetest(props) {

  const [ip, setIP] = useState('');

    useEffect(() => {      
        setTimeout(() => {
          ActivateSkyShowtime("");
        }, 500); 
    },[]);

    return (
      <div className="container">
        <header className="App-header">                  
          <p>
            Please wait for SkyShowtime test activation url...
          </p>
        </header>   
      </div>
    );
  }

export default SkyShowtimetest;
